import React, { useEffect, useRef } from "react";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import Carousel from "react-slick";
import styles from "./productSlider.scss";
import ResponsiveImg from "@tw/shared-ui-components/lib/components/responsiveImg/responsiveImg";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function SampleNextArrow(props) {
  const { onClick, name } = props;
  return (
    <div onClick={onClick}>
      <svg
        width="8"
        height="12"
        className={styles["next-btn"]}
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.37089 11.3229L7.32097 6.42747C7.55968 6.19137 7.55968 5.8086 7.32094 5.57253L2.37089 0.67706C2.13217 0.44098 1.74514 0.44098 1.5064 0.67706L0.929051 1.24804C0.690711 1.48375 0.690263 1.86575 0.928031 2.102L4.85105 5.99999L0.928031 9.898C0.690263 10.1343 0.690711 10.5163 0.929051 10.752L1.5064 11.3229C1.74511 11.559 2.13215 11.559 2.37089 11.3229Z"
          fill="#2C2C2C"
        />
      </svg>
      <svg
        width="14"
        height="24"
        viewBox="0 0 14 24"
        className={styles["next-btn-desktop"]}
        style={{ top: name == "-modal" ? "48%" : "45%" }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.76378 24C1.94751 24 2.11286 23.9457 2.25984 23.8371L13.7795 12.4344C13.9265 12.3258 14 12.181 14 12C14 11.819 13.9265 11.6742 13.7795 11.5656L2.25984 0.162896C2.11286 0.0542986 1.94751 0 1.76378 0C1.58005 0 1.43307 0.0542986 1.32283 0.162896L0.220472 1.24887C0.0734905 1.35747 0 1.50226 0 1.68326C0 1.86425 0.0734905 2.02715 0.220472 2.17195L10.1969 12L0.220472 21.8281C0.0734905 21.9729 0 22.1357 0 22.3167C0 22.4977 0.0734905 22.6425 0.220472 22.7511L1.32283 23.8371C1.43307 23.9457 1.58005 24 1.76378 24Z"
          fill="#2C2C2C"
        />
      </svg>
    </div>
  );
}
function SamplePrevArrow(props) {
  const { onClick, name } = props;
  return (
    <div onClick={onClick}>
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        className={styles["prev-btn"]}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.74331 11.323L7.32072 10.7519C7.55913 10.5161 7.55963 10.1343 7.32174 9.89798L3.39884 5.99986L7.32199 2.10199C7.55963 1.86572 7.55938 1.48383 7.32099 1.24807L6.74356 0.677023C6.50493 0.440992 6.11778 0.440992 5.87912 0.677023L0.928975 5.5724C0.690342 5.80843 0.690342 6.1913 0.928975 6.42733L5.87887 11.323C6.11753 11.559 6.50465 11.559 6.74331 11.323Z"
          fill="#2C2C2C"
        />
      </svg>
      <svg
        width="14"
        height="24"
        viewBox="0 0 14 24"
        className={styles["prev-btn-desktop"]}
        style={{ top: name == "-modal" ? "48%" : "45%" }}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.2362 0C12.0525 0 11.8871 0.0542984 11.7402 0.162895L0.220472 11.5656C0.0734901 11.6742 0 11.819 0 12C0 12.181 0.0734901 12.3258 0.220472 12.4344L11.7402 23.8371C11.8871 23.9457 12.0525 24 12.2362 24C12.4199 24 12.5669 23.9457 12.6772 23.8371L13.7795 22.7511C13.9265 22.6425 14 22.4977 14 22.3167C14 22.1357 13.9265 21.9729 13.7795 21.8281L3.80315 12L13.7795 2.17195C13.9265 2.02715 14 1.86425 14 1.68326C14 1.50226 13.9265 1.35747 13.7795 1.24887L12.6772 0.162895C12.5669 0.0542984 12.4199 0 12.2362 0Z"
          fill="#2C2C2C"
        />
      </svg>
    </div>
  );
}

export default function productSlider(props) {
  const {
    gallery,
    onClick,
    showDots,
    showArrows,
    currentIndex,
    setCurrentIndex,
    name,
  } = props;
  const sliderRef = useRef();

  const settings = {
    dots: showDots,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    arrows: showArrows,
    slidesToScroll: 1,
    dotsClass: "button__bar",
    nextArrow: <SampleNextArrow name={name} />,
    prevArrow: <SamplePrevArrow name={name} />,
    beforeChange: (current, next) => setCurrentIndex(next),
  };

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(currentIndex, true);
    }
  }, []);

  const modalClsName = "img" + name;

  const renderGalleryItem = (item) => {
    if (item.type.includes("video"))
      return (
        <div className={styles["img-wrapper"]}>
          <video
            width={200}
            height={200}
            className={styles["vid"]}
            // autoPlay
            controls
            onClick={onClick ? onClick : undefined}
          >
            <source src={item.url} type={item.type}></source>
          </video>
        </div>
      );
    if (name && name === "-modal")
      return (
        <TransformWrapper>
          <div className={styles["img-wrapper"]}>
            <TransformComponent>
              <ResponsiveImg
                src={item.url}
                alt=""
                className={styles[modalClsName]}
                onClick={onClick ? onClick : undefined}
                bestQuality
                showFallbackImg
              />
            </TransformComponent>
          </div>
        </TransformWrapper>
      );
    return (
      <div className={styles["img-wrapper"]}>
        <picture className={styles["inner-img-wrapper"]}>
          <ResponsiveImg
            // src={`${item.url}?format=webp`}
            src={item.url}
            // fallbackSrc={

            // }
            alt=""
            className={styles[modalClsName]}
            onClick={onClick ? onClick : undefined}
            bestQuality
            showFallbackImg
          />
        </picture>
      </div>
    );
  };

  return (
    <>
      <Carousel {...settings} ref={sliderRef}>
        {gallery &&
          gallery.map((item, i) => {
            return (
              <div className={styles["card-image"]} key={i}>
                {renderGalleryItem(item)}
              </div>
            );
          })}
      </Carousel>
    </>
  );
}
